<template>
  <div style="background: #fff;padding: 10px;margin-top: 10px;">

     <div class="headingss">Customer Details</div>
      <div class="row m-0 customerregform">
        
      <div class="sub-head" style="width:100%">Basic Details</div>
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Customer Name</div>
     <div class="fieldval">{{customerObj.longDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Country</div>
     <div class="fieldval">{{customerObj.countryDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">{{customerObj.idCardDesc}}</div>
     <div class="fieldval">{{customerObj.idCardValue}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Company</div>
     <div class="fieldval">{{customerObj.companyDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Sector</div>
     <div class="fieldval">{{customerObj.customerSectorDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Nature</div>
     <div class="fieldval">{{customerObj.customerNatureDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Group</div>
     <div class="fieldval">{{customerObj.customerGroupDesc}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Contact Name</div>
     <div class="fieldval">{{customerObj.contactContactName}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Contact Email</div>
     <div class="fieldval">{{customerObj.contactEmail}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Mobile Number</div>
     <div class="fieldval">{{customerObj.contactMobileNumber}}</div> </div>
      </div>
<hr>
      <div class="row m-0 customerregform">
        
      <div class="sub-head" style="width:100%">Address Details</div>
      <div class="col-12">
     <div class="fieldhead">Registered Office Address</div>
     <div class="fieldval">{{customerObj.registeredOfficeAddress.streetAddress}},
       {{customerObj.registeredOfficeAddress.countryDesc}},
       {{customerObj.registeredOfficeAddress.stateDesc}},
       {{customerObj.registeredOfficeAddress.cityDesc}},
       {{customerObj.registeredOfficeAddress.postalCode}}
     </div>
      </div>
      </div>

<hr>
 <div class="row m-0 customerregform" v-if="customerObj.countryCode == 100">
   
      <div class="sub-head" style="width:100%">Statutory Details</div>
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.gstNumber">
     <div class="fieldhead">GST Number</div>
     <div class="fieldval">{{customerObj.gstNumber}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.gstinDocumentId">
     <div class="fieldhead">GST document</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.gstinDocumentId)" href="#"  class="mt-n2"
                    >{{getFileName(customerObj.gstinDocumentId)}}</a>  </div>
                 </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.gstinDeclarationDocumentId">
     <div class="fieldhead">GST Declaration</div>  
            <div class="fieldval">
               <a @click="showAttachFile(customerObj.gstinDeclarationDocumentId)" href="#" class="mt-n2"
                    >{{getFileName(customerObj.gstinDeclarationDocumentId)}}</a>  </div>
                 </div>


                   <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.tanNumber">
     <div class="fieldhead">TAN Number</div>
     <div class="fieldval">{{customerObj.tanNumber}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.tanDocumentId">
     <div class="fieldhead">TAN document</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.tanDocumentId)" href="#"  class="mt-n2"
                    >{{getFileName(customerObj.tanDocumentId)}}</a>  </div>
                 </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.tanDeclarationDocumentId">
     <div class="fieldhead">TAN Declaration</div>  
            <div class="fieldval">
               <a @click="showAttachFile(customerObj.tanDeclarationDocumentId)" href="#" class="mt-n2"
                    >{{getFileName(customerObj.tanDeclarationDocumentId)}}</a>  </div>
                 </div>
 </div>

 
<hr v-if="customerObj.countryCode == 100">
 <div class="row m-0 customerregform" v-if="customerObj.countryCode != 100">
   
      <div class="sub-head" style="width:100%">Statutory Details</div>
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatNumber">
     <div class="fieldhead">VAT Number</div>
     <div class="fieldval">{{customerObj.vatNumber}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDocumentId">
     <div class="fieldhead">VAT document</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.vatDocumentId)" href="#"  class="mt-n2"
                    >{{getFileName(customerObj.vatDocumentId)}}</a>  </div>
                 </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDeclarationDocumentId">
     <div class="fieldhead">VAT Declaration</div>  
            <div class="fieldval">
               <a @click="showAttachFile(customerObj.vatDeclarationDocumentId)" href="#" class="mt-n2"
                    >{{getFileName(customerObj.vatDeclarationDocumentId)}}</a>  </div>
                 </div>
 </div>

  
<hr v-if="customerObj.countryCode != 100">
 
 <div class="row m-0 customerregform" >   
      <div class="sub-head" style="width:100%">Financial Details</div>
        <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Last Financial Year Turn Over</div>
     <div class="fieldval">{{customerObj.year1.turnover?customerObj.year1.turnover:'-'}}</div> 
     </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.year1.balanceSheetAttachment">
     <div class="fieldhead">Balance Sheet</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.year1.balanceSheetAttachment)" href="#"  
              class="mt-n2"
                    >{{getFileName(customerObj.year1.balanceSheetAttachment)}}</a>  </div>
                 </div>

         <div class="col-12 col-md-6 col-lg-3">
     <div class="fieldhead">Last Financial Year ITR Ref Number</div>
     <div class="fieldval">{{customerObj.year1.itrReference ? customerObj.year1.itrReference:'-'}}</div> 
     </div>

     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.year1.itrAttachment">
     <div class="fieldhead">ITR Attachment</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.year1.itrAttachment)" href="#"  
              class="mt-n2"
                    >{{getFileName(customerObj.year1.itrAttachment)}}</a>  </div>
                 </div>
     
 </div>


<hr>
 <div class="row m-0 customerregform" >
   
      <div class="sub-head" style="width:100%">Rating Details</div>
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.ratings && customerObj.ratings[0].agencyRating">
     <div class="fieldhead">CRISIL Rating</div>
     <div class="fieldval">{{customerObj.ratings[0].agencyRating}}</div> </div>
     
        <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.ratings && customerObj.ratings[0].ratingDocumentId">
     <div class="fieldhead">Rating document</div>     
            <div class="fieldval">
              <a @click="showAttachFile(customerObj.ratings[0].ratingDocumentId)" href="#"  class="mt-n2"
                    >{{getFileName(customerObj.ratings[0].ratingDocumentId)}}</a>  </div>
                 </div>
     
 </div>
 <hr>
 
      <div class="sub-head" style="width:100%">Bank Details</div>
      <div class="card-background">
        <table class="table table-striped mb-0">
          <thead>
            <tr class="oldbankheader th-left">
              <th>Account Category</th>
              <th>Account Number</th>
              <th>Payment in favour of</th>
              <th>Account Type</th>
              <th>Payment Mode</th>
              <th>Bank Name</th>
              <th v-if="customerObj.countryCode == 100">IFSC Code</th>
              <th v-if="customerObj.countryCode != 100">Swift Code</th>
              <th v-if="customerObj.countryCode != 100">IBAN Number</th>
              <th>Attachment</th>
            <th>Payment Ref Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(bank,index) in customerObj.bankList ? customerObj.bankList : []" :key="index">
              <td>{{bank.accountCategory}}</td>
              <td>{{bank.accountNumber}}</td>
              <td>{{bank.paymentInfavourOf}}</td>
              <td>{{bank.accountType}}</td>
              <td>{{bank.paymentMode}}</td>
              <td>{{bank.bankName}}</td>
              <td v-if="customerObj.countryCode == 100">{{bank.ifscCode}}</td>
              <td v-if="customerObj.countryCode != 100">{{bank.swiftBicCode}}</td>
              <td v-if="customerObj.countryCode != 100">{{bank.ibanNumber}}</td>
              <td><a
                  v-if="bank.documentId!=null"
                  @click="showFile(bank.documentId)"
                  href="#"
                >{{getAttachmentName(bank.documentId)}}</a>
                <span v-else>-</span></td>                
              <td>{{bank.paymentRefMailId}}</td>
            </tr>
          </tbody>
        </table>
        
              {{customerObj.bankList.length==0 ? 'No Branch added' : ''}}
      </div>


 <hr>
      
      <div class="sub-head" style="width:100%">Branch Details</div>
      <div class="new-branch-details-table">
          <table class="table table-striped mb-0">
            <thead>
              <tr class="oldbankheader th-left">
                <th>Branch Id</th>
                <th>Branch Name</th>
                <th>Document Number</th>
                <th>Contact Person Name</th>
                <th>Contact Number</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="cbr in customerObj.savedNewBranchResponseList" v-bind:key="cbr">
                <td>{{cbr.branchId}}</td>
                <td>{{cbr.branchName}}</td>
                <td>{{cbr.documentNumber ? cbr.documentNumber  : '-Yet to be generated-'}}</td>
                <td>{{cbr.contactPersonName}}</td>
                <td>{{cbr.mobileNumber}}</td>                
              </tr>
              </tbody>
              </table>
              {{customerObj.savedNewBranchResponseList.length==0 ? 'No Branch added' : ''}}
              </div>
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();

import { OnBoardingServices } from "../../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import moment from "moment";
import LoadingSpinner from "../../widgets/LoadingSpinner";
import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import DatePicker from "vue2-datepicker";
import partnertable from "../../widgets/partner-table-collapsable";
export default {
  props: ["answerNumber","country"],
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    "w-loading-spinner": LoadingSpinner,
    DatePicker
  },
  data() {
    return {
      loading:false,
      enableSubmit: true,
      customerObj: {},
      documentNumber: "PQL190102000001"
    }
  },
  watch: {},
  created() {
    this.getCustomerData();
  },
  computed: {},
  methods: {    
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    getFileName(fileName) {
      if (fileName != null) {
        var fileNameFinal = null;
        fileNameFinal = fileName.split(/_(.+)/)[1];
        return fileNameFinal;
      }
      return fileNameFinal;
    },
    getCustomerData() {
      var data = {
       "documentNumber":this.answerNumber 
      }
      SummaryService.getCustomerDetailsDesc(data).then(resp => {
        this.loading = false;
            if(resp.failureMessage!=""){
              window.alert(resp.failureMessage)
            } else {
               this.customerObj = (resp.response)          
            }
      })
        .catch(error => {
          console.log(error);
          window.alert(error)
            if(error.failureMessage!=""){
              window.alert(error.failureMessage)
            } else {
          window.alert('something went wrong!')
            }
        });
    },
    getAttachmentName(documentId) { 
      if (documentId) {
        let attachmentName = "";
        attachmentName = documentId.split(/_(.+)/)[1]
          ? documentId.split(/_(.+)/)[1]
          : documentId;
        return attachmentName;
      }
    },
    dateFormat(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    showFile(event) {
      this.loading = true;
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.fieldhead{text-align:left;font-weight: bold;}
.sub-head{text-align:left;font-weight: bold;font-size: 14px;}
.headingss{
text-align:left;font-weight: bold;font-size:16px;
}
.fieldval{text-align:left;}
.oldbankheader th{
    background: #949494
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.table-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
}
.header-Text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
}
</style>

<style>
.table thead th {
  font-size: 15px !important;
  font-family: "Source Sans Pro", sans-serif;
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
</style>